import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnlockAIHeader = ({
  title,
  subtitle
}) => {
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "800",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-400",
      textAlign: "center",
      children: title
    }), /*#__PURE__*/_jsx(Text, {
      textAlign: "center",
      children: subtitle !== null && subtitle !== void 0 ? subtitle : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.unlockAI.subtitle"
      })
    })]
  });
};
export default UnlockAIHeader;